import React from 'react';
import { DialerCampaignDashboard } from './pages/DialerCampaignDashboard';
export function App() {
  return <DialerCampaignDashboard data-id="element-0" />;
}